import { render, staticRenderFns } from "./MemberCreatePage.vue?vue&type=template&id=65e66400&"
import script from "./MemberCreatePage.vue?vue&type=script&lang=js&"
export * from "./MemberCreatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports